fragment SupplierControlPanelSettingFragment on SupplierControlPanelSetting {
    id
    supplier_id
    name
    mecg_sku_prefix
    original_sku_prefix
    product_discount
    print_discount
    mec_company
    merge_class
    stock_product
    unit_prefix
    delivery_time
    is_product_translator_enabled
    is_grouped_translator_enabled
}